import {
  Box,
  Button,
  Heading,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  useDisclosure,
  useToast,
  VStack
} from '@chakra-ui/react';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';

import { SuccessCheckWhiteLabel as SuccessCheck } from '../../../../assets/icons/SuccessCheck';
import { WhiteLabelWrapper } from '../../../../components/layouts/WhiteLabelWrapper';
import { WhiteLabelSteps } from '../../../../components/white-label/WhiteLabelSteps';
import { useStepsForm } from '../../../../hooks/useStepsForm';
import { apiSensedia } from '../../../../services/api-sensedia';

let apiWl = apiSensedia;

if (process.env.NODE_ENV != 'development') {
  apiWl = apiSensedia;
}

export const StepFive = (): JSX.Element => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { state } = useStepsForm();
  const { idWebsite } = useParams();
  const toast = useToast();

  const handlePreviewButton = async (codigo: string) => {
    const headers = {
      id_site: codigo as string
    };
    const axiosConfig = {
      headers: { ...headers }
    };

    try {
      let response = undefined;
      if (process.env.NODE_ENV === 'development') {
        const url = `${process.env.REACT_APP_WS_WHITELABEL_HOST}/websites/endereco-assinado`;
        response = await axios.post(url, {}, axiosConfig);
      } else {
        response = await apiWl.post(
          '/websites/endereco-assinado',
          {},
          {
            headers: { ...headers }
          }
        );
      }

      if (response.data.url) {
        const url = response.data.url;
        window.open(url, '_blank');
      } else {
        toast({
          description: 'Não foi possível abrir o preview neste momento.',
          status: 'error'
        });
      }
    } catch (error) {
      console.log(error);
      toast({
        description: 'Não foi possível abrir o preview neste momento.',
        status: 'error'
      });
    }
  };

  useEffect(() => {
    onOpen();
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <WhiteLabelWrapper>
        <Box p="40px 56px">
          <VStack gap="30px">
            <HStack w="100%" justifyContent="space-between">
              <Box>
                <Heading>Concluir</Heading>
                <Text>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry.
                  <br />
                  Lorem Ipsum has been the industry standard dummy text ever
                  since the 1500s
                </Text>
              </Box>
              <WhiteLabelSteps currentStep={5} />
            </HStack>
          </VStack>
        </Box>
      </WhiteLabelWrapper>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent maxW="1104px" borderRadius="24px">
          <ModalCloseButton />
          <ModalBody>
            <Box width="100%" h="489px">
              <VStack height="100%" justifyContent="center" gap="30px">
                <SuccessCheck w="4.625rem" h="4.624rem" />
                <VStack textAlign="center" gap=".5rem">
                  <Text
                    fontSize="1.5rem"
                    fontWeight="bold"
                    color="#006217"
                    mt="0 !important"
                  >
                    Seu site foi criado com sucesso!
                  </Text>
                  <Text w="70%" mt="0 !important">
                    Será submetido a analise da SulAmérica. (prazo 2 dias uteis)
                  </Text>
                </VStack>
                <Button
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  bg="#001E64"
                  color="white"
                  borderRadius="133.5px"
                  _hover={{ opacity: 0.8 }}
                  width="281px"
                  height="48px"
                  mt="10px !important"
                  onClick={() => {
                    handlePreviewButton(String(idWebsite));
                  }}
                >
                  Ver meu site
                </Button>
                <Button
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  borderRadius="133.5px"
                  width="281px"
                  height="48px"
                  bg="transparent"
                  color="#001E64"
                  border="1px solid #001E64"
                  mt="0 !important"
                  onClick={() => {
                    window.location.href = `/corretor/white-label/painel`;
                  }}
                >
                  Meus sites criados
                </Button>
              </VStack>
            </Box>
          </ModalBody>

          {/* <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Close
            </Button>
            <Button variant="ghost">Secondary Action</Button>
          </ModalFooter> */}
        </ModalContent>
      </Modal>
    </>
  );
};
